<template>
  <div class="container" v-if="evaluatorDataLoaded && preferenceDataLoaded">
    <h4 class="title is-4">Evaluators with preference "{{ preference.name }}"</h4>
    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Preferences</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluator in evaluators" :key="evaluator.id">
          <td>
            <router-link :to="{ name: 'EvaluatorDetail', params: { evaluatorId: evaluator.id } }">
              {{ evaluator.fullName }}
            </router-link>
          </td>
          <td>
            <span
              style="margin: .25rem"
              class="tag"
              v-for="evaluatorPreference in evaluator.preferencesRef"
              :key="evaluatorPreference.id"
              @click="refreshPageNewPreference(evaluatorPreference.id)"
            >
              {{ evaluatorPreference.name }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import store from '@/vuex/store'
import User from '@/services/users'

export default {
  data() {
    return {
      preference: {},
      evaluators: [],
      preferenceDataLoaded: false,
      evaluatorDataLoaded: false,
      evaluatorFilters: {
        isEvaluator: true,
        preferences: [],
      },
      preferenceId: null,
    }
  },
  created() {
    this.preferenceId = this.$route.params.preferenceId
    this.evaluatorFilters.preferences = []
    this.evaluatorFilters.preferences.push(this.$route.params.preferenceId)
    this.refreshData()
  },
  methods: {
    refreshPageNewPreference(preferenceId) {
      this.evaluatorFilters.preferences = []
      this.evaluatorFilters.preferences.push(preferenceId)
      this.preferenceId = preferenceId
      this.refreshData()
    },
    refreshData() {
      // TODO: Replace with new class-based model
      const preferenceURL = `preferences/${this.preferenceId}`
      const preferencePromise = store.getters.apiClient.get(preferenceURL)
      preferencePromise.then(response => {
        this.preference = response.data
        this.preferenceDataLoaded = true
      })

      User.api.list({ filters: this.evaluatorFilters }).then(data => {
        this.evaluators = data.results
        this.evaluatorDataLoaded = true
      })
    },
    updateEvaluator(evaluator, approvalStatus) {
      let newEvaluator = User.create(evaluator)
      newEvaluator.pendingAsEvaluator = !approvalStatus
      const fields = ['pendingAsEvaluator']
      User.api.update(newEvaluator, fields).then(() => {
        this.refreshData()
      })
    },
  },
}
</script>

<style scoped>
.preference {
  margin: 0 10px;
}
</style>
